/// <reference path="../setup/_references.ts" />
module onvio.firmDashboard {
    'use strict';

    /**
     * Controller for the firm dashboard
     */
    export class FirmDashboardController {
        // Bindings sent to child components
        public context: onvio.practice.widgets.IBmPracticeWidgetLoadDataArgs;
        private loadedCompanyId: string;

        public backgroundName: string;
        public isLoading: boolean = false;

        static $inject = [
            'AuthenticatedSessionData',
            'ThemeSetupManager'
        ];
        constructor(
            authenticatedSessionData: any,
            private themeSetupManager: any) {

            authenticatedSessionData.get().then((sessionData: any) => {
                this.loadedCompanyId =
                    sessionData.bindings.ApplicationConfiguration.CompanyId;

                this.themeSetupManager
                    .getFirmThemeSettings(this.loadedCompanyId)
                    .then((firmTheme: any) => {
                        this.backgroundName = firmTheme.loginBackground
                            ? firmTheme.loginBackground
                            : 'grass';
                    })
                    .catch(() => {
                        this.backgroundName = 'grass';
                    });
                this.isLoading = false;
            });

            this.initializeFirmDashboardArgs();
        }

        private initializeFirmDashboardArgs() {
            this.context = {
                startDate: moment().startOf('month').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD')
            };
        }
    }

    angular
        .module('onvio.firmDashboard.FirmDashboardController', [])
        .controller(
            'onvio.firmDashboard.FirmDashboardController',
            FirmDashboardController
        );
}
